class PrintController {

    constructor() {
        this.view = new PrintView(this.exportToPDF.bind(this));
    }

    exportToPDF() {
        this.view.exportBtn.disableButton();
        let restoreUrl = plannerApplication.yourProfile.getUrl() + '?restore=' + plannerApplication.yourProfile.getGuid();

        this.view.printScheduleSummary.empty().append(
            $('.app-schedule-summary').clone().removeClass('widget').removeClass('widget--activity'));

        this.view.printDetails.empty().append(
            $('.sidebar-your-details').clone().removeClass('widget').removeClass('widget--details'));

        this.view.printQrCode.empty();

        new QRCode(this.view.printQrCode[0], {
            text: restoreUrl,
            width: 80,
            height: 80,
            correctLevel: QRCode.CorrectLevel.M
        });

        this.view.printPlanUrl.find('a').html(restoreUrl).attr('href', restoreUrl);

        this.addScreenshots();
    }

    addScreenshots() {
        this.screenshots = 0;
        //let hrs = plannerApplication.controllers.scheduleController.calendarController.setPrintMode();
        //let height = (20*hrs)+25;
        //this.view.printCalendar.css('height', ''+height+'px');
        addScreenshot(this.view.sourceLogo, this.view.printLogo, this.finishScreenshots.bind(this));
        addScreenshot(this.view.sourceCalendar, this.view.printCalendarImg, this.finishScreenshots.bind(this), 1200, 1500);
    }

    finishScreenshots() {

        this.screenshots += 1;
        if (this.screenshots === 2) {
            //plannerApplication.controllers.scheduleController.calendarController.setWebMode();
            let printHtml = this.view.rootNode.html();
            appLog(printHtml);
            let key = plannerApplication.yourProfile.getGuid();

            plannerApplication.api.requestPrint(key, printHtml, function () {
                this.view.exportBtn.disableButton();
                let printUrl = plannerApplication.config.serverUrl + '/print/'
                    + plannerApplication.config.brand + '/study_planner/' + key + '/';
                window.open(printUrl, '_blank').focus();
            }.bind(this));
        }
    }

}
